export default __webpack_public_path__ + "static/media/blackpaper.893adc6f.jpg";